import React, { useMemo } from "react";

// Lightweight CSS-only dust particles. No external dependency.
export const Particles = ({ count = 28 }) => {
  const dots = useMemo(() => {
    const arr = [];
    for (let i = 0; i < count; i++) {
      const size = Math.random() * 2.4 + 0.6;
      arr.push({
        id: i,
        left: `${Math.random() * 100}%`,
        size: `${size}px`,
        duration: `${14 + Math.random() * 22}s`,
        delay: `${Math.random() * -30}s`,
        opacity: 0.25 + Math.random() * 0.45,
        color: Math.random() > 0.7 ? "#8A2BE2" : "#D4AF37",
      });
    }
    return arr;
  }, [count]);

  return (
    <div
      aria-hidden
      data-testid="particles-layer"
      className="pointer-events-none absolute inset-0 overflow-hidden"
    >
      {dots.map((d) => (
        <span
          key={d.id}
          className="particle"
          style={{
            left: d.left,
            width: d.size,
            height: d.size,
            background: d.color,
            animationDuration: d.duration,
            animationDelay: d.delay,
            opacity: d.opacity,
            bottom: "-10px",
          }}
        />
      ))}
    </div>
  );
};

export default Particles;
